import { Navigate } from "react-router-dom";
import InvalidLogin from "../pages/Login/InvalidLogin/InvalidLogin";
import Landing from "../pages/Login/Landing/Landing";
import { Route_types } from "../types/routes/RouteTypes";
import { Routes } from "../enums/Routes";

const AppRoutes: Route_types[] = [
  {
    path: Routes.Login,
    element: <Landing />
  },
  {
    path: Routes.Invalid,
    element: <InvalidLogin />
  },
  {
    path: "*",
    element: <Navigate to={Routes.Login} />
  }
];

export default AppRoutes;
